<!-- Noticias.vue -->
<template>
  <section class="noticias">
    <h2>Últimas Noticias</h2>
    <div class="noticias-grid">
      <div class="noticia" v-for="(item, index) in noticias" :key="index">
        <img :src="item.img" :alt="item.titulo" />
        <p class="fecha">{{ item.fecha }}</p>
        <h3>{{ item.titulo }}</h3>
        <p class="descripcion">{{ item.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NoticiaWorld',
  data() {
    return {
 noticias: [
  {
    img: 'https://img.freepik.com/foto-gratis/tecnico-reparando-tableta-laboratorio_23-2149375793.jpg',
    fecha: '29 de agosto de 2025',
    titulo: 'Jean Informático se une a Inter para ofrecer soluciones educativas',
    descripcion: 'La alianza busca mejorar el acceso a reparaciones tecnológicas en instituciones académicas, con conectividad estable gracias a Inter.'
  },
  {
    img: 'https://img.freepik.com/foto-gratis/tecnico-reparando-smartphone-mesa-trabajo_23-2149375789.jpg',
    fecha: '29 de agosto de 2025',
    titulo: 'Cashea ahora disponible como método de pago en servicios de Jean Informático',
    descripcion: 'Los clientes podrán pagar en cuotas sin interés por reparaciones y productos tecnológicos, gracias a la integración con Cashea.'
  },
  {
    img: 'https://img.freepik.com/foto-gratis/mano-sosteniendo-smartphone-aplicaciones-tecnologia_23-2149375801.jpg',
    fecha: '29 de agosto de 2025',
    titulo: 'Inter y Jean Informático amplían cobertura técnica en toda Venezuela',
    descripcion: 'Con el respaldo de Inter, Jean Informático ofrecerá soporte técnico y productos digitales en más de 40 ciudades del país.'
  }
]


    };
  }
};
</script>

<style scoped>
.noticias {
  background: linear-gradient(to bottom, #0b1c3f, #091a36);
  color: white;
  padding: 3rem 1rem;
  text-align: center;
  overflow: hidden;
}

.noticias h2 {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  position: relative;
  animation: fadeInDown 1s ease forwards;
  text-shadow: 0 0 10px #00bfff;
}

.noticias-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: center;
  animation: fadeInUp 1.2s ease forwards;
}

.noticia {
  background-color: #132a50;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 320px;
  box-shadow: 0 0 15px rgba(0, 191, 255, 0.2);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  opacity: 0;
  animation: slideUp 1s ease forwards;
  animation-delay: calc(0.2s * var(--i));
}

.noticia:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 0 25px rgba(0, 191, 255, 0.4);
}

.noticia img {
  width: 100%;
  border-radius: 6px;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
}

.noticia:hover img {
  transform: scale(1.05);
}

.fecha {
  font-size: 0.85rem;
  color: #a0c4ff;
  margin-bottom: 0.5rem;
  font-style: italic;
  opacity: 0.8;
}

.noticia h3 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #ffffff;
  transition: color 0.3s ease;
}

.noticia:hover h3 {
  color: #00bfff;
}

.descripcion {
  font-size: 0.95rem;
  line-height: 1.4;
  color: #dbeafe;
}

.leer-mas {
  display: inline-block;
  margin-top: 2rem;
  color: #00bfff;
  text-decoration: none;
  font-weight: bold;
  position: relative;
  transition: color 0.3s ease;
}

.leer-mas::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background-color: #00bfff;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.leer-mas:hover {
  color: #ffffff;
}

.leer-mas:hover::after {
  transform: scaleX(1);
}

/* Animaciones */
@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .noticias h2 {
    font-size: 2rem;
  }

  .noticia {
    max-width: 90%;
  }
}

</style>
